export default __webpack_public_path__ + "static/the-best-and-worst-transport-around-the-world-fea70639af1603c872e4920daa29782d.jpg";